export default function swiper() {
  const bannerHomeSwiper = new Swiper('.ingredients-information-swiper', {
    modules: [Navigation, EffectFade, Pagination],
    watchSlidesProgress: true,
    spaceBetween: 130,
    slidesPerView: 1,
    loop: true,
    allowTouchMove: true,
    navigation: {
      nextEl: '.ingredients-information .swiper-button-next',
      prevEl: '.ingredients-information .swiper-button-prev',
    },
    pagination: {
      el: '.ingredients-information .swiper-pagination',
    },
  })

  const newsLetterSwiper = new Swiper('.news-letter-swiper', {
    modules: [Navigation, EffectFade, Pagination],
    watchSlidesProgress: true,
    spaceBetween: 40,
    slidesPerView: 1,
    loop: true,
    allowTouchMove: true,
    pagination: {
      el: '.swiper-pagination',
    },
  })
}
